import { useEffect, useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  SemiConfigFormValues,
  specificationItem,
  PhysicalMaterialTypes,
} from '../ProductsConfiguration'
import StepTitle from '../StepTitle'
import CircleLoader from '@src/components/CircleLoader'
import useSpecifications from '../useSpecifications'
import PhysicalMaterial from './PhysicalMaterial'
import RNASpecifications from './RNASpecifications'

const useStyles = makeStyles((theme: Theme) => ({
  requiredText: {
    paddingTop: theme.spacing(1),
    '& p': {
      fontSize: theme.typography.pxToRem(12),
    },
  },
  sequenceWithAsterisk: {
    paddingBottom: `${theme.typography.pxToRem(8)}!important`,
  },
}))

const Specifications = () => {
  const formik = useFormikContext<SemiConfigFormValues>()
  const classes = useStyles()
  const { SpecificationsQuery } = useSpecifications()
  const [physicalMaterial, setReqPhysicalMaterial] = useState<
    specificationItem[]
  >([])
  const [species, setSpecies] = useState<specificationItem[]>([])
  const [structure, setStructure] = useState<specificationItem[]>([])
  const [scale, setScale] = useState<specificationItem[]>([])
  const [modification, setModification] = useState<specificationItem[]>([])
  const [purification, setPurification] = useState<specificationItem[]>([])
  const [format, setFormat] = useState<specificationItem[]>([])
  useEffect(() => {
    const loadData = async () => {
      const data = await SpecificationsQuery({})
      if (data.physicalMaterial) setReqPhysicalMaterial(data.physicalMaterial)
      if (data.species) setSpecies(data.species)
      if (data.structure) setStructure(data.structure)
      if (data.scale) setScale(data.scale)
      if (data.modification) setModification(data.modification)
      if (data.purification) setPurification(data.purification)
      if (data.format) setFormat(data.format)
    }
    loadData()
  }, [formik.values.specifications])

  return (
    <Grid container>
      <StepTitle
        title={
          <FormattedMessage
            id="SPECIFICATIONS"
            defaultMessage="Specifications"
          />
        }
      />
      <Grid item xs={12} className={classes.requiredText}>
        <Typography variant="body1">
          *
          <FormattedMessage
            id="REQUIRED_FIELDS"
            defaultMessage="Required Fields"
          />
        </Typography>
      </Grid>
      <PhysicalMaterial physicalMaterialList={physicalMaterial} />
      {formik.values.specifications.physicalMaterial ===
        PhysicalMaterialTypes.RNA && (
        <RNASpecifications
          speciesList={species}
          structureList={structure}
          scaleList={scale}
          modificationList={modification}
          purificationList={purification}
          formatList={format}
        />
      )}
      {formik.values?.loading && <CircleLoader />}
    </Grid>
  )
}

export default Specifications
